export default '2.6.3';



// WEBPACK FOOTER //
// ./src/lib/version.js